import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Locations from '@/views/Locations';
import Menus from '@/views/Menus';
import Directories from '@/views/Directories';
import Vocabulary from '@/views/Vocabulary';
import Sites from '@/views/Sites';
import Centros from '@/views/Centros';
import RiskMatrixAdmin from '@/views/RiskMatrixAdmin';
import UsersView from '@/views/Users';
import Roles from '@/views/Roles';
import Page404 from '@/views/404';
import TodoListView from '@/views/TodoListView';
import GenericExplorerView from '@/views/GenericExplorerView';
import GlobalSearch from '@/components/explorer/GlobalSearch';
import ExplorerCalendar from '@/components/explorer/ExplorerCalendar';
import PDFViewer from '@/views/PDFViewer';
import BPExplorerTable from '@/components/bpexplorer/BPExplorerTable';
import BPCreator from '@/views/BPCreator';

Vue.use(Router);

const SEDE_PATTERN = "/sede/:sede";  // centro url
const CORP_PATTERN = "/corp/:corp";  // enterprise url

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${SEDE_PATTERN}/about`,
      name: 'sedeabout',
      component: About,
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${SEDE_PATTERN}`,
      // Redirect: /sede/misede → /sede/misede/login
      redirect: to => {
        return { path: `/sede/${to.params.sede}/login` };
      },
    },
    {
      path: `${SEDE_PATTERN}/login`,
      name: 'sedelogin',
      component: () => import('./views/Login.vue'),
    },
    {
      path: `${CORP_PATTERN}/about`,
      name: 'corpabout',
      component: About,
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${CORP_PATTERN}`,
      // Redirect: /sede/misede → /sede/misede/login
      redirect: to => {
        return { path: `/corp/${to.params.corp}/login` };
      },
    },
    {
      path: `${CORP_PATTERN}/login`,
      name: 'corplogin',
      component: () => import('./views/Login.vue'),
    },
    {
      path: `/login`,
      name: 'login',
      // hack for not showing local login
      // TODO condition using Vue.config.SSO
      beforeEnter: () => location.assign(Vue.config.SSO.loginURL),
      // component: () => import('./views/Login.vue'),
    },
    {
      path: '*/logout',
      name: 'logout',
      component: () =>
        import(/* webpackChunkName: "logout" */ './views/Logout.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ssologin',
      name: 'ssologin',
      beforeEnter: () => location.assign(Vue.config.SSO.loginURL)
    },
    {
      path: '/ssocallback',
      name: 'ssocallback',
      component: () => import('./views/SSOCallback.vue')
    },
    {
      path: '*/ssologout',
      name: 'ssologout',
      beforeEnter: () => location.replace(Vue.config.SSO.logoutURL)
    },
    {
      path: '*/processes',
      name: 'processes',
      component: () =>
        // import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/processes_old',
      name: 'processes_old',
      component: () =>
         import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        //import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '*/preferences',
      name: 'preferences',
      component: () =>
        import(/* webpackChunkName: "preferences" */ './views/Preferences.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/roles',
      name: 'roles',
      component: Roles,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '*/sites',
      name: 'sites',
      component: Sites,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/centros',
      name: 'centros',
      component: Centros,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/risk_matrix',
      name: 'risk_matrix',
      component: RiskMatrixAdmin,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/users',
      name: 'users',
      component: UsersView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/locations',
      name: 'locations',
      component: Locations,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/explorer',
      name: 'explorer',
      component: GenericExplorerView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/explorerCalendar',
      name: 'explorerCalendar',
      component: ExplorerCalendar,
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '*/menus',
      name: 'menus',
      component: Menus,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/directories',
      name: 'directories',
      component: Directories,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/vocabularies',
      name: 'vocabularies',
      component: Vocabulary,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/pdf',
      name: 'pdf',
      component: PDFViewer,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/todoList',
      name: 'todoList',
      component: TodoListView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/search',
      name: 'search',
      component: GlobalSearch,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '*/bpexplorertable',
      name: 'BPExplorerTable',
      component: BPExplorerTable,
      meta: {
        requiresAuth: true,
      },
    },
    {
      // will match everything
      path: '*',
      component: Page404,
    },
    {
      path: '*/bpplayground',
      name: 'bp',
      component: BPCreator,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

export default router;
